import { render, staticRenderFns } from "./dialog_batchDel.vue?vue&type=template&id=14541a48&scoped=true&"
import script from "./dialog_batchDel.vue?vue&type=script&lang=js&"
export * from "./dialog_batchDel.vue?vue&type=script&lang=js&"
import style0 from "./dialog_batchDel.vue?vue&type=style&index=0&id=14541a48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14541a48",
  null
  
)

export default component.exports